import { ConfigRepository } from '../../../../shared/repositories/config.repository';
import { inject } from '@angular/core';
import { SessionRepository } from '../../../../shared/repositories/session.repository';
import { AddressDto } from '../../../../api/v1/models/address-dto';
import { Observable } from 'rxjs';
import { CoordinatesDto } from '../../../../api/v1/models/coordinates-dto';

export abstract class FormSaveStrategy {
  protected configRepository: ConfigRepository = inject(ConfigRepository);
  protected sessionRepository: SessionRepository = inject(SessionRepository);

  abstract get debounceTimeout(): number;

  abstract setActiveOutlet(outletId: number, isUserChoose: boolean): void;
  abstract setDeliveryAddress(address: AddressDto, coordinates?: CoordinatesDto | null): Observable<AddressDto>;
}
